import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdjustedTenorForHolidayEventImplEncoder } from "../../encoder/AdjustedTenorForHolidayEventImplEncoder";

import * as CubiqTS from "../../index";
import { AdjustedTenorForHolidayEvent } from "../AdjustedTenorForHolidayEvent";

export class AdjustedTenorForHolidayEventImpl
  extends ConcreteEncodable
  implements AdjustedTenorForHolidayEvent
{
  public static enType: string = "com.bcdfx.model.event.AdjustedTenorForHolidayEventImpl";

  /*FID=1*/
  public baseCcyCd: string;
  /*FID=2*/
  public nonBaseCcyCd: string;
  /*FID=3*/
  public tenor: CubiqTS.Tenor;
  /*FID=4*/
  public adjustedTenor: CubiqTS.Tenor;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdjustedTenorForHolidayEventImplEncoder.Instance;
    this.setEncodableType(AdjustedTenorForHolidayEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdjustedTenorForHolidayEventImpl[" +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "tenor=" +
      this.tenor +
      "adjustedTenor=" +
      this.adjustedTenor +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
